export default __webpack_public_path__ + "static/media/AVX430.be585ea8.png";